/* istanbul ignore file */
import {Global} from '@emotion/react';
import React from 'react';
import {Helmet} from 'react-helmet-async';

import {Container, PageTitle, Panel} from '@br/mg-components';

const Legal = ({title, terms}: {title: string | null; terms: string}) => {
    if (!title) {
        throw Error('Cannot detect page title from terms page.'); // eslint-disable-line i18next/no-literal-string
    }

    return (
        <>
            {title && <Helmet title={title} />}

            <Global
                styles={{
                    'a:not([href]), a:not([href]):hover': {
                        textDecoration: 'none',
                        color: '#000',
                    },
                }}
            />
            <Container>
                <Panel>
                    <PageTitle title={title} />
                    <div
                        data-testid="legal-text"
                        dangerouslySetInnerHTML={{
                            __html: terms,
                        }}
                    ></div>
                </Panel>
            </Container>
        </>
    );
};

export default Legal;
